import PropTypes from "prop-types"
import React from "react"
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom"

import RouteErrorFallback from "src/components/ErrorBoundaryProvider/RouteErrorFallback"

import { getCurrentMarinaSlug } from "src/utils/url/parsing/marina"

import AccountingView from "./AccountingView"
import ExportTab from "./ExportTab"
import ItemMappingTab from "./ItemMappingTab"
import ManageTab from "./ManageTab"
import MappingTab from "./MappingTab"
import RevenueMappingTab from "./RevenueMappingTab"
import SetupTab from "./SetupTab"
import SyncTab from "./SyncTab"

const AccountingRouter = ({
  integration,
  accountingBases,
  accountingService,
  connectionGuideUrl,
  accountingV2Enabled,
  userHasAdminRole,
  categoryOptions,
}) => {
  const marinaSlug = getCurrentMarinaSlug()

  const router = createBrowserRouter(
    [
      {
        path: "/",
        errorElement: <RouteErrorFallback />,
        element: (
          <AccountingView
            integration={integration}
            accountingBases={accountingBases}
            accountingService={accountingService}
            connectionGuideUrl={connectionGuideUrl}
            marinaSlug={marinaSlug}
            accountingV2Enabled={accountingV2Enabled}
            userHasAdminRole={userHasAdminRole}
            categoryOptions={categoryOptions}
          />
        ),
        children: [
          {
            index: true,
            element: (
              <Navigate
                to={
                  integration?.setupComplete
                    ? accountingV2Enabled
                      ? "/sync"
                      : "/export"
                    : "/setup"
                }
              />
            ),
          },
          {
            path: "/setup",
            element: <SetupTab />,
          },
          {
            path: accountingV2Enabled ? "/item_mapping" : "/manage",
            element: accountingV2Enabled ? <ItemMappingTab /> : <ManageTab />,
          },
          {
            path: accountingV2Enabled ? "/revenue_mapping" : "/mapping",
            element: accountingV2Enabled ? (
              <RevenueMappingTab />
            ) : (
              <MappingTab />
            ),
          },
          {
            path: accountingV2Enabled ? "/sync" : "/export",
            element: accountingV2Enabled ? <SyncTab /> : <ExportTab />,
          },
        ],
      },
    ],
    { basename: `/manage/${marinaSlug}/accounting` }
  )

  return <RouterProvider router={router} />
}

AccountingRouter.propTypes = {
  integration: PropTypes.shape({
    id: PropTypes.number.isRequired,
    setupComplete: PropTypes.bool.isRequired,
    accountingBasis: PropTypes.string,
    serviceId: PropTypes.string.isRequired,
    dynamicConfiguration: PropTypes.object.isRequired,
    preparing: PropTypes.bool.isRequired,
    status: PropTypes.oneOf(["active", "inactive"]).isRequired,
  }),
  accountingBases: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  accountingService: PropTypes.shape({
    name: PropTypes.string.isRequired,
    serviceId: PropTypes.string.isRequired,
  }),
  connectionGuideUrl: PropTypes.string.isRequired,
  accountingV2Enabled: PropTypes.bool.isRequired,
  userHasAdminRole: PropTypes.bool.isRequired,
  categoryOptions: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
    .isRequired,
}

export default AccountingRouter
